import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { useCountryRedirect } from '@/hooks/country-redirect';
import { Button } from '@starsoft/common/components';
import { useLottiePlayer } from '@starsoft/common/hooks';

export default function CountryRedirectContent() {
  const { t } = useTranslation('common');
  const { title, description, redirectById, redirectUrl } =
    useCountryRedirect();
  const { lottieAnimationRef } = useLottiePlayer({
    path: '/world-location.json',
  });

  function handleRedirect() {
    window.open(redirectUrl, '_self');
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <div
          className={styles.container__content__lottie}
          ref={lottieAnimationRef}
        />
        <h1 className={styles.container__content__title}>{title}</h1>
        <p className={styles.container__content__description}>{description}</p>
      </div>
      <Button onClick={handleRedirect}>
        {t('country_redirect_button', {
          app_provider: redirectById?.redirect?.url,
        })}
      </Button>
    </div>
  );
}
